import { motionDisabled } from '@/shared/lib/motion';
import { useEffect, useRef, useState, type ReactNode } from 'react';

/**
 * השהיית unmount לאנימציית יציאה (עיצוב v2: מודל/מגירה נסגרים באנימציה).
 * בזמן היציאה מוצג "צילום" של הילדים מהרינדור הפתוח האחרון — הורים רבים
 * מאפסים את הנתונים יחד עם הסגירה, ורינדור חי שלהם היה נופל על null.
 */
export function usePresence(isOpen: boolean, children: ReactNode, exitMs = 220) {
  const [mounted, setMounted] = useState(isOpen);
  const [leaving, setLeaving] = useState(false);
  const last = useRef<ReactNode>(children);
  if (isOpen) last.current = children;

  useEffect(() => {
    if (isOpen) {
      setMounted(true);
      setLeaving(false);
      return;
    }
    if (!mounted) return;
    const reduce = motionDisabled();
    if (reduce || exitMs <= 0) { setMounted(false); return; }
    setLeaving(true);
    const t = window.setTimeout(() => { setMounted(false); setLeaving(false); }, exitMs);
    return () => window.clearTimeout(t);
  }, [isOpen, mounted, exitMs]);

  return { mounted: isOpen || mounted, leaving: !isOpen && leaving, content: isOpen ? children : last.current };
}
